import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { TagColor } from '../../data/tag.model';
import { TAG_COLOR_CONFIG } from '../colors';

@Component({
  selector: 'dojo-tag-badge',
  template: `
    <span
      class="inline-flex h-[22px] items-center gap-1 truncate rounded-md px-1.5 text-xs font-semibold"
      [ngClass]="['bg-dynamic-' + colorClassName() + '-100', 'text-dynamic-' + colorClassName() + '-700']"
    >
      @if (emoji()) {
        <span class="text-xs" [ngClass]="['text-dynamic-' + colorClassName() + '-700']">{{ emoji() }}</span>
      }
      <span class="truncate" [matTooltip]="name()">{{ name() }}</span>
    </span>
  `,
  host: { class: 'flex' },
  imports: [NgClass, MatTooltipTruncateDirective, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagBadgeComponent {
  readonly name = input.required<string>();
  readonly color = input<TagColor>('amber');
  readonly emoji = input<string | null>(null);

  readonly colorClassName = computed(
    () => TAG_COLOR_CONFIG[this.color()]?.badgeColorName ?? TAG_COLOR_CONFIG.amber.badgeColorName,
  );
}
